var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "ca-form" },
      [
        _c(
          "el-form",
          {
            ref: "productForm",
            staticClass: "form-container",
            attrs: {
              model: _vm.productForm,
              rules: _vm.rules,
              autocomplete: "on",
              "label-position": "left",
              size: "minix",
            },
          },
          [
            _c(
              "div",
              { staticClass: "ca-single-line" },
              [
                _c(
                  "el-form-item",
                  { staticClass: "w-50", attrs: { label: "Order Type" } },
                  [
                    _c("OrderTypeOption", {
                      model: {
                        value: _vm.productForm.orderTypeId,
                        callback: function ($$v) {
                          _vm.$set(_vm.productForm, "orderTypeId", $$v)
                        },
                        expression: "productForm.orderTypeId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.productForm.productId,
                        expression: "productForm.productId",
                      },
                    ],
                    staticClass: "w-50",
                    attrs: { label: "Product Id" },
                  },
                  [_vm._v(" " + _vm._s(_vm.productForm.productId) + " ")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "ca-single-line" },
              [
                _c(
                  "el-form-item",
                  { staticClass: "w-50", attrs: { label: "Product Name" } },
                  [
                    _c("el-input", {
                      attrs: {
                        maxlength: "50",
                        placeholder: "Short Product Name",
                      },
                      model: {
                        value: _vm.productForm.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.productForm, "name", $$v)
                        },
                        expression: "productForm.name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "w-50",
                    attrs: { label: "Report Title Override" },
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        maxlength: "100",
                        placeholder: "Report Title (optional)",
                      },
                      model: {
                        value: _vm.productForm.reportTitleOverride,
                        callback: function ($$v) {
                          _vm.$set(_vm.productForm, "reportTitleOverride", $$v)
                        },
                        expression: "productForm.reportTitleOverride",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "ca-single-line" }, [
              _c("h4", [_vm._v("Vendor Selection Settings")]),
            ]),
            _c(
              "div",
              { staticClass: "ca-single-line" },
              [
                _c(
                  "el-form-item",
                  { staticClass: "w-50", attrs: { label: "Broadcast Limit" } },
                  [
                    _c("el-input", {
                      attrs: { type: "number", min: 1, max: 50 },
                      model: {
                        value: _vm.productForm.broadcastLimit,
                        callback: function ($$v) {
                          _vm.$set(_vm.productForm, "broadcastLimit", $$v)
                        },
                        expression: "productForm.broadcastLimit",
                      },
                    }),
                    _c("span", [_vm._v(" maximum # of vendors to contact")]),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { staticClass: "w-50", attrs: { label: "Time Limit" } },
                  [
                    _c("el-input", {
                      attrs: { type: "number", min: 1, max: 10 },
                      model: {
                        value: _vm.productForm.assignmentTimeout,
                        callback: function ($$v) {
                          _vm.$set(_vm.productForm, "assignmentTimeout", $$v)
                        },
                        expression: "productForm.assignmentTimeout",
                      },
                    }),
                    _c("span", [_vm._v(" accept within X business days")]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "ca-single-line" },
              [
                _c(
                  "el-form-item",
                  { staticClass: "w-50", attrs: { label: "Distance Limit" } },
                  [
                    _c("el-input", {
                      attrs: { type: "number", min: 1, max: 50 },
                      model: {
                        value: _vm.productForm.distanceLimit,
                        callback: function ($$v) {
                          _vm.$set(_vm.productForm, "distanceLimit", $$v)
                        },
                        expression: "productForm.distanceLimit",
                      },
                    }),
                    _c("span", [_vm._v(" miles from vendor location")]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "ca-single-line" }, [
              _c("h4", [_vm._v("Pricing and Fees")]),
            ]),
            _c(
              "div",
              { staticClass: "ca-single-line" },
              [
                _c(
                  "el-form-item",
                  { staticClass: "w-50", attrs: { label: "Client Price" } },
                  [
                    _c("el-input", {
                      attrs: { type: "number", min: 1, max: 100 },
                      model: {
                        value: _vm.productForm.listPrice,
                        callback: function ($$v) {
                          _vm.$set(_vm.productForm, "listPrice", $$v)
                        },
                        expression: "productForm.listPrice",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { staticClass: "w-50", attrs: { label: "Vendor Fee" } },
                  [
                    _c("el-input", {
                      attrs: { type: "number", min: 1, max: 100 },
                      model: {
                        value: _vm.productForm.vendorFee,
                        callback: function ($$v) {
                          _vm.$set(_vm.productForm, "vendorFee", $$v)
                        },
                        expression: "productForm.vendorFee",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "ca-single-line" }, [
              _c("h4", [_vm._v("Product Add-ons")]),
            ]),
            _c(
              "div",
              { staticClass: "ca-single-line" },
              [
                _c(
                  "el-form-item",
                  { staticClass: "w-50", attrs: { label: "AVM Report" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { "value-key": "key" },
                        model: {
                          value: _vm.productForm.avmReportAddOn,
                          callback: function ($$v) {
                            _vm.$set(_vm.productForm, "avmReportAddOn", $$v)
                          },
                          expression: "productForm.avmReportAddOn",
                        },
                      },
                      _vm._l(_vm.avmOptions, function (item) {
                        return _c(
                          "el-option",
                          {
                            key: item.key,
                            attrs: { label: item.name, value: item.key },
                          },
                          [_vm._v(" " + _vm._s(item.name) + " ")]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "w-50",
                    attrs: { label: "Internal Notes", prop: "description" },
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        maxlength: "200",
                        placeholder: "Notes (optional)",
                      },
                      model: {
                        value: _vm.productForm.description,
                        callback: function ($$v) {
                          _vm.$set(_vm.productForm, "description", $$v)
                        },
                        expression: "productForm.description",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "dialog-footer",
        staticStyle: { "text-align": "center", "margin-top": "10px" },
        attrs: { slot: "footer" },
        slot: "footer",
      },
      [
        _c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("Cancel")]),
        _c(
          "el-button",
          { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
          [_vm._v("Save Product")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }